import React, { useState, useEffect } from "react";
// import MapModal from './Map'; // 제거

function ConnectTab({ connectGroups, onDeleteGroup, onLabelChange, onAddGroup, onChangeGroupTitle, zoom, showAllMarkers, onShowOnMap }) {
  // 20241028.json 데이터
  const [busStopData, setBusStopData] = useState([]);
  const [editingRoute, setEditingRoute] = useState(null); // 편집 중인 노선
  const [editText, setEditText] = useState(''); // 편집 텍스트
  // 그룹 추가 함수 (props로 onAddGroup이 없으면 내부에서 처리)
  const [editingTitleIdx, setEditingTitleIdx] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");
  // mapModalOpen, mapModalRoutes, mapModalLabels 등 지도 모달 관련 상태 모두 제거
  // const [importCode, setImportCode] = useState(""); // 코드 입력 상태 제거
  // importModalOpen, setImportModalOpen은 URL 입력 모달로 재활용
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [importUrl, setImportUrl] = useState(""); // URL 입력 상태 추가

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/20241028.json")
      .then(res => res.json())
      .then(data => {
        setBusStopData(data);
      })
      .catch(err => {
        // 무시
      });
  }, []);

  // 좌표로 가장 가까운 정류장 찾기


  // 노선명 기본 색상 규칙 (모든 노선을 초록색으로)
  
  // getDefaultColor 함수, colors 관련 상태, props, 변수, UI, JSON 변환 등 모두 제거

  // 텍스트 편집 시작
  const handleEditStart = (groupIdx, routeIdx, currentText) => {
    setEditingRoute({ groupIdx, routeIdx });
    setEditText(currentText || '');
  };

  // 텍스트 편집 완료
  const handleEditComplete = () => {
    if (editingRoute && onLabelChange) {
      onLabelChange(editingRoute.groupIdx, editingRoute.routeIdx, editText);
    }
    setEditingRoute(null);
    setEditText('');
  };

  // 텍스트 편집 취소
  const handleEditCancel = () => {
    setEditingRoute(null);
    setEditText('');
  };

  // ESC 키로 편집 취소
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && editingRoute) {
        handleEditCancel();
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [editingRoute]);

  // 지도 보기 버튼 클릭 시
  const handleShowMap = (group) => {
    if (onShowOnMap) {
      onShowOnMap(group.routes, group.labels, group.title || (group.routes.length === 1 ? group.routes[0].routeName : ''));
    }
  };

  // 클립보드 복사 함수
  const handleCopyGroupCode = (group) => {
    // 그룹명, 각 노선별 메모, 색상 포함, interval만 제거, cityCode는 포함
    const groupToCopy = {
      title: group.title || '',
      routes: (group.routes || []).map((route, idx) => {
        const { interval, ...rest } = route;
        return {
          ...rest,
          routeType: route.routeType, // routeType도 복사
          label: group.labels && group.labels[idx] ? group.labels[idx] : ''
        };
      })
    };
    // 줄넘김 없이 한 줄로 복사
    const code = JSON.stringify(groupToCopy);
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code);
      alert("코드가 클립보드에 복사되었습니다.");
    } else {
      // fallback
      const textarea = document.createElement("textarea");
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("코드가 클립보드에 복사되었습니다.");
    }
  };

  // 코드로 그룹 추가 함수 제거
  // URL로 그룹 추가 함수 추가
  const handleAddGroupByUrl = async () => {
    if (!importUrl) {
      alert("URL을 입력하세요.");
      return;
    }
    let group = null;
    let isJson = false;
    try {
      const res = await fetch(importUrl);
      group = await res.json();
      isJson = true;
    } catch (e) {
      // fetch 실패 시 URL 파라미터 직접 파싱 시도
      try {
        // routes= 이후 문자열 추출
        let url = importUrl;
        let routesStr = "";
        if (url.includes("routes=")) {
          routesStr = url.split("routes=")[1];
          // #, ? 등 뒤에 다른 파라미터가 있으면 잘라냄
          routesStr = routesStr.split("#")[0].split("&")[0];
        } else {
          alert("URL에 routes= 파라미터가 없습니다.");
          return;
        }
        // 마지막에 ; 또는 $로 끝나면 제거
        if (routesStr.endsWith(";")) routesStr = routesStr.slice(0, -1);
        if (routesStr.endsWith("$")) routesStr = routesStr.slice(0, -1);
        routesStr = decodeURIComponent(routesStr);
        const routeStrArr = routesStr.split(";").filter(Boolean);
        const routes = [];
        const labels = [];
        const colors = [];
        for (let routeStr of routeStrArr) {
          const arr = routeStr.split("$");
          if (arr.length < 10) continue;
          routes.push({
            routeId: arr[0],
            cityCode: arr[1],
            routeType: arr[2],
            routeName: arr[3],
            boarding: {
              lat: parseFloat(arr[4]),
              lng: parseFloat(arr[5]),
              name: arr[6]
            },
            alighting: {
              lat: parseFloat(arr[7]),
              lng: parseFloat(arr[8]),
              name: arr[9]
            }
          });
          labels.push(arr[10] ? arr[10] : "");
          colors.push("");
        }
        if (routes.length === 0) {
          alert("파싱된 노선 데이터가 없습니다.");
          return;
        }
        group = { title: "URL 그룹", routes, labels, colors };
      } catch (err) {
        alert("URL에서 데이터를 불러오지 못했습니다: " + err.message);
        return;
      }
    }
    if (group && group.routes) {
      if (!isJson) {
        // 이미 labels, colors 포함됨
        if (typeof onAddGroup === 'function') {
          onAddGroup(group);
        }
        alert("노선 그룹이 추가되었습니다.");
        setImportUrl("");
        setImportModalOpen(false);
        return;
      }
      // JSON 정상 fetch 시 기존 로직
      const labels = Array.isArray(group.routes)
        ? group.routes.map(r => r.label || "")
        : [];
      const colors = Array.isArray(group.routes)
        ? group.routes.map(r => r.color || "")
        : [];
      const routes = group.routes.map(({ label, color, ...rest }) => ({ ...rest, routeType: rest.routeType }));
      const groupToAdd = { ...group, routes, labels, colors };
      if (typeof onAddGroup === 'function') {
        onAddGroup(groupToAdd);
      }
      alert("노선 그룹이 추가되었습니다.");
      setImportUrl("");
      setImportModalOpen(false);
    } else {
      alert("올바른 그룹 데이터가 아닙니다.");
    }
  };

  const handleEditTitleStart = (idx, currentTitle) => {
    setEditingTitleIdx(idx);
    setEditingTitle(currentTitle || "");
  };
  const handleEditTitleComplete = (idx) => {
    if (typeof onChangeGroupTitle === 'function') {
      onChangeGroupTitle(idx, editingTitle);
    } else if (connectGroups[idx]) {
      connectGroups[idx].title = editingTitle;
    }
    setEditingTitleIdx(null);
    setEditingTitle("");
  };

  // 노선유형별 색상 반환 함수
  function getRouteTypeColor(routeType) {
    switch (routeType) {
      case '공항': return '#00bfff'; // 하늘색
      case '마을': return '#a0d468'; // 연두색
      case '간선': return '#3498db'; // 파란색
      case '지선': return '#27ae60'; // 초록색
      case '일반': return '#32cd32'; // 라임색
      case '순환': return '#f1c40f'; // 노란색
      case '광역': return '#e74c3c';
      case '급행': return '#ff7f00';//주황
      case '직행좌석': return '#e60012'; // 빨간색
      case '좌석': return '#9999ff';

      case '농어촌(일반)': return '#ffd400'; // 노란색

      case '인천': return '#32cd32'; // 라임색
      case '경기': return '#32cd32'; // 라임색
      case '관광': return '#8b00ff'; // 보라색

      default: return '#000'; // 기본 검정
    }
  }

  return (
    <div style={{ padding: 16 }}>
      <h2>노선 그룹</h2>
      {/* 코드 입력 및 추가 UI - 버튼만 남기고, 모달로 이동 */}
      <button onClick={() => setImportModalOpen(true)} style={{ marginBottom: 16, padding: '8px 16px', fontSize: 16, background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', marginRight: 8 }}>
          URL로 그룹 추가
        </button>
      {(connectGroups).length > 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          maxHeight: '50vh',
          overflowY: 'scroll',
          border: '1px solid #eee',
          borderRadius: 8,
          padding: 4,
          background: '#fafbfc',
          scrollbarWidth: 'thin',
          scrollbarColor: '#bbb #fafbfc'
        }}>
          {connectGroups.map((group, groupIdx) => {
            // 콘솔에 그룹 정보 출력

            
            return (
              <div key={groupIdx} style={{ background: '#f8f8f8', padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', position: 'relative' }}>
                {/* 삭제 버튼 - X, 정사각형, 우상단 */}
                <button
                  onClick={() => {
                    if (window.confirm('노선 그룹을 삭제하시겠습니까?')) {
                      onDeleteGroup && onDeleteGroup(groupIdx);
                    }
                  }}
                  style={{
                    position: 'absolute', right: 28, top: 17, width: 28, height: 28,
                    background: '#e74c3c', color: '#fff', border: 'none', fontSize: 18, fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0
                  }}
                  title="삭제"
                >
                  X
                </button>
                {/* 지도(🌍) 버튼 - 우하단 */}
                <button
                  onClick={() => handleShowMap(group)}
                  style={{
                    position: 'absolute', right: 40, top: 60, width: 28, height: 28,
                    background: 'none', border: 'none', fontSize: 30, cursor: 'pointer', lineHeight: 1
                  }}
                  title="지도에서 보기"
                >🗺️</button>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <div style={{ fontWeight: 'bold', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                    {editingTitleIdx === groupIdx ? (
                      <>
                        <input
                          value={editingTitle}
                          onChange={e => setEditingTitle(e.target.value)}
                          style={{ fontSize: 16, fontWeight: 'bold', border: '1px solid #ccc', borderRadius: 4, padding: '2px 8px', width: 150 }}
                          onKeyDown={e => { if (e.key === 'Enter') handleEditTitleComplete(groupIdx); }}
                          autoFocus
                        />
                        <button onClick={() => handleEditTitleComplete(groupIdx)} style={{ marginLeft: 4, fontSize: 14, padding: '2px 8px', borderRadius: 4, border: 'none', background: '#27ae60', color: '#fff', cursor: 'pointer' }}>저장</button>
                      </>
                    ) : (
                      <>
                        {group.title || `목록 (${groupIdx + 1})`}
                        <button onClick={() => handleEditTitleStart(groupIdx, group.title || `목록 (${groupIdx + 1})`)} style={{ marginLeft: 4, fontSize: 14, padding: '2px 8px', borderRadius: 4, border: 'none', background: '#888', color: '#fff', cursor: 'pointer' }}>편집</button>
                      </>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {/* 기존 지도/삭제 버튼 제거됨 */}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', paddingRight: 80, marginTop: 20 }}>
                  {group.routes.map((info, i) => {


                    const isEditing = editingRoute && editingRoute.groupIdx === groupIdx && editingRoute.routeIdx === i;
                    const currentLabel = group.labels && group.labels[i] ? group.labels[i] : '';
                    
                    return (
                      <div key={i} style={{ position: 'relative' }}>
                        {isEditing ? (
                          // 편집 모드
                          <>
                            {/* 배경 오버레이 */}
                            <div 
                              style={{ 
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                background: 'rgba(0,0,0,0.5)',
                                zIndex: 999
                              }}
                              onClick={handleEditCancel}
                            />
                            {/* 모달 창 */}
                            <div style={{ 
                              position: 'fixed',
                              top: '30%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: '90vw',
                              background: '#fff',
                              border: '2px solid #3498db',
                              borderRadius: 12,
                              padding: 24,
                              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                              zIndex: 1000
                            }}>
                              <div style={{ marginBottom: 8, fontSize: 18, fontWeight: 'bold', color: getRouteTypeColor(info.routeType), textAlign: 'center' }}>
                                {info.routeName}
                              </div>

                              <textarea
                                value={editText}
                                onChange={e => setEditText(e.target.value)}
                                style={{
                                  width: '95%',
                                  height: '30vh',
                                  fontSize: 16,
                                  border: '1px solid #ddd',
                                  borderRadius: 8,
                                  padding: 12,
                                  resize: 'none',
                                  fontFamily: 'inherit'
                                }}
                                placeholder="'//'전후로 승하차 메모 구분"
                                autoFocus
                              />
                              <div style={{ 
                                display: 'flex', 
                                gap: 12, 
                                justifyContent: 'center',
                                marginTop: 16
                              }}>
                                <button
                                  onClick={handleEditComplete}
                                  style={{
                                    padding: '12px 24px',
                                    fontSize: 16,
                                    background: '#27ae60',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 8,
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    minWidth: 80
                                  }}
                                >
                                  확인
                                </button>
                                <button
                                  onClick={handleEditCancel}
                                  style={{
                                    padding: '12px 24px',
                                    fontSize: 16,
                                    background: '#e74c3c',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 8,
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    minWidth: 80
                                  }}
                                >
                                  취소
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          // 일반 모드
                          <span 
                            onClick={() => handleEditStart(groupIdx, i, currentLabel)}
                            style={{ 
                              color: getRouteTypeColor(info.routeType), 
                              fontWeight: 'bold', 
                              fontSize: 15, 
                              border: '1px solid #ddd', 
                              borderRadius: 6, 
                              padding: '2px 10px', 
                              background: '#fff',
                              cursor: 'pointer',
                              display: 'inline-block',
                              minWidth: 20,
                              textAlign: 'center'
                            }}
                            title={currentLabel ? `메모: ${currentLabel}` : '클릭하여 메모 입력'}
                          >
                            {info.routeName}

                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div>연결된 노선이 없습니다.</div>
      )}
      {/* URL 입력 모달 */}
      {importModalOpen && (
        <>
          {/* 배경 오버레이 */}
          <div 
            style={{ 
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 9999
            }}
            onClick={() => setImportModalOpen(false)}
          />
          {/* 모달 창 */}
          <div style={{ 
            position: 'fixed',
            top: '30%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90vw',
            maxWidth: 800,
            background: '#fff',
            border: '2px solid #3498db',
            borderRadius: 12,
            padding: 24,
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            zIndex: 10000
          }}>
            <div style={{ marginBottom: 8, fontSize: 18, fontWeight: 'bold', color: '#000000', textAlign: 'center' }}>
              URL로 노선 그룹 추가
            </div>
            <input
              type="text"
              value={importUrl}
              onChange={e => setImportUrl(e.target.value)}
              style={{
                width: '95%',
                fontSize: 16,
                border: '1px solid #ddd',
                borderRadius: 8,
                padding: 12,
                marginBottom: 16
              }}
              placeholder="지도 창에서 복사한 URL 붙여넣기"
              autoFocus
            />
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 8 }}>
              <button
                onClick={handleAddGroupByUrl}
                style={{
                  padding: '12px 24px',
                  fontSize: 16,
                  background: '#27ae60',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  minWidth: 80
                }}
              >
                추가
              </button>
              <button
                onClick={() => setImportModalOpen(false)}
                style={{
                  padding: '12px 24px',
                  fontSize: 16,
                  background: '#e74c3c',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  minWidth: 80
                }}
              >
                취소
              </button>
            </div>
          </div>
        </>
      )}
      {/* 코드 입력 모달만 남기고, MapModal 모달 완전히 제거 */}
    </div>
  );
}

export default ConnectTab;
